module.exports = __webpack_public_path__ + "img/img2.54774b22.png";